import React from 'react';

const FleetIllustration = () => (
  <svg viewBox="0 0 500 480" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: 'auto', filter: 'drop-shadow(0 20px 40px rgba(245, 124, 32, 0.08))' }}>
    {/* Orbiting rings */}
    <circle cx="250" cy="220" r="145" stroke="#F5D5B5" strokeWidth="1.5" strokeDasharray="6 6" opacity="0.5">
      <animateTransform attributeName="transform" type="rotate" from="0 250 220" to="360 250 220" dur="60s" repeatCount="indefinite" />
    </circle>
    <circle cx="250" cy="220" r="105" stroke="#F5D5B5" strokeWidth="1" strokeDasharray="4 8" opacity="0.35">
      <animateTransform attributeName="transform" type="rotate" from="360 250 220" to="0 250 220" dur="45s" repeatCount="indefinite" />
    </circle>

    {/* Server blocks row */}
    <g transform="translate(115, 330)">
      <rect width="78" height="48" rx="6" fill="#FEF3C7" stroke="#F59E0B" strokeWidth="1.5" />
      <rect x="10" y="12" width="28" height="3.5" rx="2" fill="#F59E0B" opacity="0.5" />
      <rect x="10" y="21" width="18" height="3.5" rx="2" fill="#F59E0B" opacity="0.3" />
      <rect x="10" y="30" width="38" height="3.5" rx="2" fill="#F59E0B" opacity="0.4" />
      <circle cx="62" cy="14" r="4" fill="#34D399" />
      <circle cx="62" cy="26" r="4" fill="#34D399" opacity="0.5" />
    </g>
    <g transform="translate(210, 348)">
      <rect width="78" height="48" rx="6" fill="#FEF3C7" stroke="#F59E0B" strokeWidth="1.5" />
      <rect x="10" y="12" width="22" height="3.5" rx="2" fill="#F59E0B" opacity="0.5" />
      <rect x="10" y="21" width="32" height="3.5" rx="2" fill="#F59E0B" opacity="0.3" />
      <rect x="10" y="30" width="14" height="3.5" rx="2" fill="#F59E0B" opacity="0.4" />
      <circle cx="62" cy="14" r="4" fill="#34D399" />
      <circle cx="62" cy="26" r="4" fill="#FBBF24" />
    </g>
    <g transform="translate(305, 330)">
      <rect width="78" height="48" rx="6" fill="#FEF3C7" stroke="#F59E0B" strokeWidth="1.5" />
      <rect x="10" y="12" width="32" height="3.5" rx="2" fill="#F59E0B" opacity="0.5" />
      <rect x="10" y="21" width="42" height="3.5" rx="2" fill="#F59E0B" opacity="0.3" />
      <rect x="10" y="30" width="22" height="3.5" rx="2" fill="#F59E0B" opacity="0.4" />
      <circle cx="62" cy="14" r="4" fill="#34D399" />
      <circle cx="62" cy="26" r="4" fill="#34D399" opacity="0.5" />
    </g>

    {/* Base platform */}
    <ellipse cx="255" cy="395" rx="148" ry="18" fill="#FDE68A" opacity="0.35" />

    {/* Cloud */}
    <g>
      <ellipse cx="265" cy="165" rx="30" ry="22" fill="#FDBA74" opacity="0.28" />
      <ellipse cx="287" cy="170" rx="20" ry="16" fill="#FDBA74" opacity="0.22" />
      <ellipse cx="247" cy="171" rx="18" ry="14" fill="#FDBA74" opacity="0.18" />
      <animateTransform attributeName="transform" type="translate" values="0,0; 8,-3; 0,0" dur="8s" repeatCount="indefinite" />
    </g>

    {/* Monitor with chart */}
    <g transform="translate(95, 185)">
      <rect width="108" height="78" rx="8" fill="#FFF" stroke="#E5E7EB" strokeWidth="1.5" />
      <rect x="8" y="8" width="92" height="50" rx="4" fill="#7C3AED" opacity="0.08" />
      <rect x="16" y="36" width="9" height="18" rx="2" fill="#8B5CF6" opacity="0.7" />
      <rect x="29" y="28" width="9" height="26" rx="2" fill="#8B5CF6" opacity="0.8" />
      <rect x="42" y="22" width="9" height="32" rx="2" fill="#8B5CF6" />
      <rect x="55" y="32" width="9" height="22" rx="2" fill="#8B5CF6" opacity="0.6" />
      <rect x="68" y="18" width="9" height="36" rx="2" fill="#F57C20" />
      <rect x="81" y="26" width="9" height="28" rx="2" fill="#F57C20" opacity="0.7" />
      <rect x="44" y="78" width="20" height="12" fill="#E5E7EB" />
      <rect x="34" y="90" width="40" height="4" rx="2" fill="#D1D5DB" />
    </g>

    {/* GPS marker */}
    <g>
      <path d="M350 155 C350 144 340 135 330 135 C320 135 310 144 310 155 C310 170 330 190 330 190 C330 190 350 170 350 155Z" fill="#F57C20" />
      <circle cx="330" cy="155" r="10" fill="white" />
      <circle cx="330" cy="155" r="5" fill="#F57C20" />
      <animateTransform attributeName="transform" type="translate" values="0,0; 0,-5; 0,0" dur="3s" repeatCount="indefinite" />
    </g>

    {/* Network dashed lines */}
    <line x1="175" y1="240" x2="280" y2="195" stroke="#F57C20" strokeWidth="1" strokeDasharray="4 4" opacity="0.4">
      <animate attributeName="stroke-dashoffset" from="0" to="16" dur="2s" repeatCount="indefinite" />
    </line>
    <line x1="280" y1="195" x2="330" y2="175" stroke="#F57C20" strokeWidth="1" strokeDasharray="4 4" opacity="0.4">
      <animate attributeName="stroke-dashoffset" from="0" to="16" dur="2s" repeatCount="indefinite" />
    </line>
    <line x1="250" y1="290" x2="180" y2="250" stroke="#8B5CF6" strokeWidth="1" strokeDasharray="4 4" opacity="0.3">
      <animate attributeName="stroke-dashoffset" from="0" to="16" dur="3s" repeatCount="indefinite" />
    </line>

    {/* Vehicle */}
    <g transform="translate(225, 248)">
      <rect x="0" y="8" width="48" height="22" rx="6" fill="#F57C20" />
      <rect x="5" y="0" width="26" height="14" rx="4" fill="#FB923C" />
      <circle cx="11" cy="32" r="6" fill="#1F2937" />
      <circle cx="11" cy="32" r="3" fill="#6B7280" />
      <circle cx="37" cy="32" r="6" fill="#1F2937" />
      <circle cx="37" cy="32" r="3" fill="#6B7280" />
    </g>

    {/* Person with device */}
    <g transform="translate(335, 250)">
      <circle cx="18" cy="10" r="12" fill="#FBBF24" />
      <ellipse cx="18" cy="38" rx="15" ry="17" fill="#F59E0B" />
      <rect x="9" y="42" width="13" height="20" rx="3" fill="#374151" />
      <rect x="11" y="45" width="9" height="13" rx="1" fill="#60A5FA" opacity="0.6" />
    </g>

    {/* Shield */}
    <g>
      <path d="M178 118 L164 124 V134 C164 143.5 178 152 178 152 C178 152 192 143.5 192 134 V124 L178 118Z" fill="none" stroke="#34D399" strokeWidth="2" />
      <path d="M172 134 L176 138 L184 130" stroke="#34D399" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <animateTransform attributeName="transform" type="translate" values="0,0; 0,-4; 0,0" dur="4s" repeatCount="indefinite" />
    </g>

    {/* Satellite signal */}
    <g transform="translate(385, 105)">
      <circle cx="14" cy="14" r="6" fill="#3B82F6" />
      <circle cx="14" cy="14" r="12" fill="none" stroke="#3B82F6" strokeWidth="1.5" opacity="0.4">
        <animate attributeName="r" values="12;20;12" dur="3s" repeatCount="indefinite" />
        <animate attributeName="opacity" values="0.4;0;0.4" dur="3s" repeatCount="indefinite" />
      </circle>
      <circle cx="14" cy="14" r="20" fill="none" stroke="#3B82F6" strokeWidth="1" opacity="0.2">
        <animate attributeName="r" values="20;28;20" dur="3s" repeatCount="indefinite" />
        <animate attributeName="opacity" values="0.2;0;0.2" dur="3s" repeatCount="indefinite" />
      </circle>
    </g>

    {/* Data flow arrows */}
    <g opacity="0.5">
      <path d="M255 300 L255 340" stroke="#F57C20" strokeWidth="1.5" strokeDasharray="3 3">
        <animate attributeName="stroke-dashoffset" from="0" to="-12" dur="1.5s" repeatCount="indefinite" />
      </path>
      <path d="M165 300 L165 330" stroke="#F59E0B" strokeWidth="1.5" strokeDasharray="3 3">
        <animate attributeName="stroke-dashoffset" from="0" to="-12" dur="1.8s" repeatCount="indefinite" />
      </path>
      <path d="M345 300 L345 330" stroke="#F59E0B" strokeWidth="1.5" strokeDasharray="3 3">
        <animate attributeName="stroke-dashoffset" from="0" to="-12" dur="2s" repeatCount="indefinite" />
      </path>
    </g>
  </svg>
);

export default FleetIllustration;
